module.exports = __webpack_public_path__ + "img/weix.c3d975b4.png";